import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IMsfFormBuilder} from '@components/form-builder/form-builder';
import {DynamicDataTableComponent} from '@components/dynamic-data-table/dynamic-data-table.component';
import {TableColumn} from '@components/data-table/data-table.component';
import {ListPageWrapper} from '@app/wrappers/pages/list-page-wrapper/list-page-wrapper';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SortType} from '@6grain/masofa-monolith-api-client/crop-monitoring/model/sortType';
import {RequestParams} from '@components/select/resource-component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'list-table-without-filters-wrapper',
  templateUrl: './list-table-without-filters-wrapper.html',
  styleUrl: './list-table-without-filters-wrapper.scss',
  standalone: true,
  imports: [
    DynamicDataTableComponent,
    ListPageWrapper,
    CommonModule,
    FormsModule,
    TranslatePipe
  ]
})
export class ListTableWithoutFiltersWrapper {

  @Input() filtersForms: IMsfFormBuilder[] = [];
  @Input({required: true}) toggleFilter: boolean | undefined = undefined;
  @Input({required: true}) isLoading: boolean = false;
  @Input({required: true}) storageKey: string | any = '';
  @Input({required: true}) service: any;
  @Input({required: true}) getAllMethod: string = '';
  @Input() getTotalMethod: string | undefined = undefined;
  @Input({required: true}) filtersParams: Object[] = [];
  @Input() columns: TableColumn[] = [];
  @Input() subtitle!: string; // Title to display
  @Input() parentRoute!:string;
  @Input() methodWithParams = true;


  @Input() defaultParams: RequestParams = {
    take: 10,
    offset: 0,
    filters: []
  }

  // Emits the current page rows from DynamicDataTable; typing as any[] to allow table data passthrough
  @Output() currentPageData = new EventEmitter<any>();

  @Output() onRowClick = new EventEmitter<any>();
}
